import api from './api';

export async function getUserById(userId) {
  const response = await api.get(`/admin/users/${userId}`);
  return response.data;
}

export async function updateUserStatus(userId, status) {
  const response = await api.patch(`/admin/users/${userId}/status`, { status });
  return response.data;
}

export async function getUsers(page = 1, limit = 10, status, gender, search) {
  const params = { page, limit };
  if (status) {
    params.status = status;
  }
  if (gender) {
    params.gender = gender;
  }
  if (search) {
    params.search = search;
  }
  const response = await api.get('/admin/users', { params });
  return response.data;
}

export async function addPetals(userId, petal) {
  const response = await api.post('/admin/add-petal', { petal, user_id: userId });
  return response.data;
}
